import React, { useEffect, useState } from "react";
import images from "../../Constant/images";
import { Container, EachChart, ChartContent, Icon } from "./styles";
import Colors from "../../Constant/Colors";
import SchoolIcon from "@mui/icons-material/School";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import GradeIcon from "@mui/icons-material/Grade";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import FolderComponent from "../../Components/FolderComponent";
import UserListComponent from "../../Components/UserListComponent";
import {
  BoldLg,
  BoldSm,
  HorizontalLeftAlign,
  SpaceBetween,
} from "../../Components/CustomStyles";
import { useDispatch, useSelector } from "react-redux";
import {
  getCoursesRequest,
  getDashboardRequest,
  getUsersRequest,
} from "../../Redux/actions/home";

const DashboardPage = ({}) => {
  const dispatch = useDispatch();
  const { isInstructor } = useSelector((state) => state.auth);
  const { total_courses, total_students, userList, credit_hours, grades } =
    useSelector((state) => state.home);
  const iconStyle = {
    color: Colors.primary,
    fontSize: 20,
    marginRight: 10,
  };

  const ChartIcon = ({ id, isInstructor }) => {
    switch (id) {
      case 0:
        return isInstructor ? (
          <PeopleAltIcon style={iconStyle} />
        ) : (
          <AccessTimeIcon style={iconStyle} />
        );
      case 1:
        return <SchoolIcon style={iconStyle} />;
      case 2:
        return isInstructor ? (
          <AccountBalanceIcon style={iconStyle} />
        ) : (
          <GradeIcon style={iconStyle} />
        );
      default:
        return null;
    }
  };
  const [charts, setCharts] = useState([
    {
      id: 0,
      title: isInstructor ? "Total Students" : "Total Credit Hours",
      image: images.barChart,
      avg: isInstructor ? total_students : credit_hours,
      percentage: 5.4,
      icon: isInstructor ? (
        <PeopleAltIcon style={iconStyle} />
      ) : (
        <AccessTimeIcon style={iconStyle} />
      ),
    },
    {
      id: 1,
      title: "Courses",
      image: images.lineChart,
      avg: total_courses,
      percentage: 15,
      icon: <SchoolIcon style={iconStyle} />,
    },
    {
      id: 2,
      title: isInstructor ? "Earnings" : "Grades",
      image: images.lineChart2,
      avg: "0",
      percentage: 15,
      icon: isInstructor ? (
        <AccountBalanceIcon style={iconStyle} />
      ) : (
        <GradeIcon style={iconStyle} />
      ),
    },
  ]);
  useEffect(() => {
    let data = { offset: 0 };
    dispatch(getUsersRequest(data));
    dispatch(getCoursesRequest());
    dispatch(getCoursesRequest(0, 100, true));
    dispatch(getDashboardRequest());
  }, []);
  useEffect(() => {
    setCharts([
      {
        id: 0,
        title: isInstructor ? "Total Students" : "Total Credit Hours",
        image: images.barChart,
        avg: isInstructor ? total_students : credit_hours,
        percentage: 5.4,
      },
      {
        id: 1,
        title: "Courses",
        image: images.lineChart,
        avg: total_courses,
        percentage: 15,
      },
      {
        id: 2,
        title: isInstructor ? "Earnings" : "Grades",
        image: images.lineChart2,
        avg: isInstructor ? 0 : grades ? grades.toFixed(2) : 0,
        percentage: 15,
      },
    ]);
  }, [total_courses, total_students]);
  return (
    <Container isInstructor={isInstructor}>
      <ChartContent>
        {charts.map((each) => (
          <EachChart key={each?.id}>
            <SpaceBetween>
              <HorizontalLeftAlign>
                <span>{ChartIcon(each?.id, isInstructor)}</span>
                <BoldLg>{each?.title}</BoldLg>
              </HorizontalLeftAlign>
              <BoldSm>{`${each?.avg}`}</BoldSm>
            </SpaceBetween>
            <Icon src={each?.image} style={{ width: "100%", height: "65px" }} />
          </EachChart>
        ))}
      </ChartContent>
      {isInstructor && <FolderComponent />}
      <UserListComponent list={userList} />
    </Container>
  );
};

export default DashboardPage;
